import React, { useState, useEffect, useContext } from "react"
import { FirebaseContext } from "../components/firebase"
import { useQueryParam, NumberParam } from "use-query-params"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import FormControl from "@material-ui/core/FormControl"
import Select from "@material-ui/core/Select"
import GameCard from "../components/game"
import Paper from "@material-ui/core/Paper"
import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import MuiDialogContent from "@material-ui/core/DialogContent"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import PredictionCard from "../components/predictionCard"
import GameService from "../components/gamesService"

const GamesPage = props => {
  const { firebase, user } = useContext(FirebaseContext)
  const [season, setSeason] = useQueryParam("season", NumberParam)
  const [week, setWeek] = useQueryParam("week", NumberParam)
  const [schedule, setSchedule] = useState([])
  const [activeGame, setActiveGame] = useState(null)
  const [open, setOpen] = React.useState(false)

  const getGames = async () => {
    if (!!season && !!week) {
      setSchedule([])
      const games = await GameService().getSchedule({ season, week })
      setSchedule(games)
    }
  }

  const handleClose = () => {
    setOpen(false)
    setActiveGame(null)
  }

  useEffect(() => {
    getGames()
  }, [season, week])

  return (
    <React.Fragment>
      {!!season && !!week ? (
        <React.Fragment>
          <div>
            {schedule.length === 0 ? (
              <div>
                <div className="spinner">
                  <div className="dot1"></div>
                  <div className="dot2"></div>
                </div>
                <h3
                  style={{
                    textAlign: "center",
                    fontWeight: "normal",
                    margin: 0,
                  }}
                >
                  Analyzing games for {season} week {week}
                </h3>
              </div>
            ) : (
              <div>
                <h2 style={{ textAlign: "center", fontWeight: "normal" }}>
                  Predictions for week {week} games for the {season} season
                </h2>
                <Grid container spacing={3}>
                  {schedule.map(game => (
                    <Grid key={game.eid} item sm={6} xs={12} md={3}>
                      <GameCard
                        onClick={eid => {
                          setActiveGame(eid)
                          setOpen(true)
                        }}
                        {...game}
                      />
                    </Grid>
                  ))}
                </Grid>
              </div>
            )}
          </div>
        </React.Fragment>
      ) : (
        <Grid
          container
          justify="center"
          alignContent="center"
          alignItems="center"
        >
          <Grid item xs={12} sm={8}>
            <Paper
              style={{
                padding: "1em",
              }}
            >
              <h2>Please Select a Season and Week Number</h2>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 10,
                }}
              >
                <FormControl>
                  <InputLabel id="demo-simple-select-label">
                    <span
                      style={{
                        padding: "10px",
                      }}
                    >
                      Season
                    </span>
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={season || -1}
                    onChange={event => {
                      setSeason(event.target.value)
                      getGames()
                    }}
                    variant="outlined"
                  >
                    <MenuItem value={-1}>
                      <em></em>
                    </MenuItem>
                    <MenuItem value={2020}>2020</MenuItem>
                    <MenuItem value={2019}>2019</MenuItem>
                    <MenuItem value={2018}>2018</MenuItem>
                    <MenuItem value={2017}>2017</MenuItem>
                  </Select>
                </FormControl>
                <FormControl>
                  <InputLabel id="demo-simple-select-label">
                    <span
                      style={{
                        padding: "10px",
                      }}
                    >
                      Week Number
                    </span>
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={week || -1}
                    onChange={event => {
                      setWeek(event.target.value)
                      getGames()
                    }}
                    variant="outlined"
                  >
                    <MenuItem value={-1}>
                      <em></em>
                    </MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                    <MenuItem value={13}>13</MenuItem>
                    <MenuItem value={14}>14</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={16}>16</MenuItem>
                    <MenuItem value={17}>17</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Paper>
          </Grid>
        </Grid>
      )}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullScreen
      >
        <MuiDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          style={{ width: "500px" }}
        >
          <Typography>
            {activeGame ? activeGame.home_team : null} vs{" "}
            {activeGame ? activeGame.away_team : null}
            <IconButton
              style={{
                position: "absolute",
                right: 5,
                top: 5,
              }}
              aria-label="close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          {activeGame && firebase && user && (
            <PredictionCard {...activeGame} firebase={firebase} user={user} />
          )}
        </MuiDialogContent>
      </Dialog>
    </React.Fragment>
  )
}

export default GamesPage
